"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
exports.type = type;
exports.isWindow = isWindow;
exports.isEmptyObject = isEmptyObject;
exports.isFunction = isFunction;
exports.isNumeric = isNumeric;
exports.isPlainObject = isPlainObject;
exports.extend = extend;
exports.each = each;
exports.isPromise = isPromise;
exports.objectEqual = objectEqual;
exports.isArraylike = isArraylike;
exports.default = exports.browerType = exports.isArray = void 0;

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

// 类转类型
var class2type = {};
var core_hasOwn = class2type.hasOwnProperty; // 对象是否是数组

var isArray = Array.isArray || function (obj) {
  return type(obj) === 'array';
};

exports.isArray = isArray;
var browerType = navigator.userAgent.match(/AppleWebKit.*Mobile.*/) ? 'mobile' : 'pc';
exports.browerType = browerType;

function noop() {} // 获取对象类型


function type(obj) {
  if (obj == null) {
    return String(obj);
  }

  return (0, _typeof2.default)(obj) === 'object' || typeof obj === 'function' ? class2type[class2type.toString.call(obj)] || 'object' : (0, _typeof2.default)(obj);
} // 判断对象是否是window


function isWindow(obj) {
  /* jshint eqeqeq: false */
  return obj != null && obj == obj.window;
} // 判断对象是否是空对象


function isEmptyObject(obj) {
  var name;

  for (name in obj) {
    return false;
  }

  return true;
} // 对象是否是方法类型


function isFunction(obj) {
  return type(obj) === 'function';
} // 判断对象是否是数值


function isNumeric(obj) {
  return !isNaN((0, _parseFloat2.default)(obj)) && isFinite(obj);
} // 判断是否普通对象


function isPlainObject(obj) {
  var key; // Must be an Object.
  // Because of IE, we also have to check the presence of the constructor property.
  // Make sure that DOM nodes and window objects don't pass through, as well

  if (!obj || type(obj) !== 'object' || obj.nodeType || isWindow(obj)) {
    return false;
  }

  try {
    // Not own constructor property must be Object
    if (obj.constructor && !core_hasOwn.call(obj, 'constructor') && !core_hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')) {
      return false;
    }
  } catch (e) {
    // IE8,9 Will throw exceptions on certain host objects #9897
    return false;
  } // Own properties are enumerated firstly, so to speed up,
  // if last one is own, then all properties are own.


  for (key in obj) {}

  return key === undefined || core_hasOwn.call(obj, key);
} // 扩展对象


function extend() {
  var src;
  var copyIsArray;
  var copy;
  var name;
  var options;
  var clone;
  var target = arguments[0] || {};
  var i = 1;
  var length = arguments.length;
  var deep = false; // Handle a deep copy situation

  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {}; // skip the boolean and the target

    i = 2;
  } // Handle case when target is a string or something (possible in deep copy)


  if ((0, _typeof2.default)(target) !== 'object' && !isFunction(target)) {
    target = {};
  } // extend smarket itself if only one argument is passed


  if (length === i) {
    target = this;
    --i;
  }

  for (; i < length; i++) {
    // Only deal with non-null/undefined values
    if ((options = arguments[i]) != null) {
      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name]; // Prevent never-ending loop

        if (target === copy) {
          continue;
        } // Recurse if we're merging plain objects or arrays


        if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && isArray(src) ? src : [];
          } else {
            clone = src && isPlainObject(src) ? src : {};
          } // Never move original objects, clone them


          target[name] = extend(deep, clone, copy); // Don't bring in undefined values
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  } // Return the modified object


  return target;
} // 遍历方法


function each(obj, callback, args) {
  var value;
  var i = 0;
  var length = obj.length;
  var isArray = isArraylike(obj);

  if (args) {
    if (isArray) {
      for (; i < length; i++) {
        value = callback.apply(obj[i], args);

        if (value === false) {
          break;
        }
      }
    } else {
      for (i in obj) {
        value = callback.apply(obj[i], args);

        if (value === false) {
          break;
        }
      }
    } // A special, fast, case for the most common use of each

  } else if (isArray) {
    for (; i < length; i++) {
      value = callback.call(obj[i], i, obj[i]);

      if (value === false) {
        break;
      }
    }
  } else {
    for (i in obj) {
      value = callback.call(obj[i], i, obj[i]);

      if (value === false) {
        break;
      }
    }
  }

  return obj;
}

function isPromise(e) {
  return !!e && typeof e.then === 'function';
}

function objectEqual(a, b) {
  var attr;

  for (attr in a) {
    if (b.hasOwnProperty(attr)) {
      if (a[attr] != b[attr]) {
        return false;
      }
    } else {
      return false;
    }
  }

  for (attr in b) {
    if (a.hasOwnProperty(attr)) {
      if (a[attr] != b[attr]) {
        return false;
      }
    } else {
      return false;
    }
  }

  return true;
} // 判断对象是否为类数组类型


function isArraylike(obj) {
  var length = obj.length;
  var objType = type(obj);

  if (isWindow(obj)) {
    return false;
  }

  if (obj.nodeType === 1 && length) {
    return true;
  }

  return objType === 'array' || objType !== 'function' && (length === 0 || typeof length === 'number' && length > 0 && length - 1 in obj);
}

each('Boolean Number String Function Array Date RegExp Object Error'.split(' '), function (i, name) {
  class2type["[object ".concat(name, "]")] = name.toLowerCase();
});
var _default = {
  isArray: isArray,
  isArraylike: isArraylike,
  noop: noop,
  browerType: browerType,
  type: type,
  isWindow: isWindow,
  isEmptyObject: isEmptyObject,
  isFunction: isFunction,
  isNumeric: isNumeric,
  isPlainObject: isPlainObject,
  extend: extend,
  each: each,
  isPromise: isPromise,
  objectEqual: objectEqual
};
exports.default = _default;